'use client'
import {
  useSubscription
} from "./chunk-NAUELPNF.mjs";
import {
  useUserSubscription
} from "./chunk-DZQX2LRT.mjs";

// src/hooks/useSubscriptionBenefits.ts
import { useEffect, useMemo } from "react";
import { useGetSubscriptionActions } from "@wbk/api/hooks";
import { ApiConfig } from "@wbk/api";
import { createCookie } from "@wbk/utils";
import { useRouter } from "@wbk/config";
var useSubscriptionBenefits = ({
  action = "purchase_priority",
  event,
  valueType = "max",
  selectedSlot
}) => {
  var _a;
  const { active } = useSubscription();
  const { locale } = useRouter();
  const { subscriptions } = useUserSubscription();
  const { data, isLoading, error, refetch } = useGetSubscriptionActions(
    {
      actions: [action],
      slug: event.slug,
      lang: locale,
      selected_timeslot: selectedSlot
    },
    {
      enabled: active && !!((_a = event.subscription_benefits) == null ? void 0 : _a[action]),
      staleTime: Infinity,
      gcTime: Infinity
    }
  );
  useEffect(() => {
    var _a2, _b, _c, _d, _e, _f, _g, _h;
    const newToken = (_a2 = data == null ? void 0 : data[action]) == null ? void 0 : _a2.access_token;
    if (newToken) {
      createCookie({
        name: "token",
        value: newToken,
        expiration: (_d = (_c = (_b = ApiConfig) == null ? void 0 : _b.config) == null ? void 0 : _c.cookie) == null ? void 0 : _d.tokenExpiration,
        domain: (_g = (_f = (_e = ApiConfig) == null ? void 0 : _e.config) == null ? void 0 : _f.cookie) == null ? void 0 : _g.domain
      });
    }
    const queueJump = action === "queue_jump_online" && Number((_h = data == null ? void 0 : data[action]) == null ? void 0 : _h.value) > 0;
    if (newToken || queueJump) {
      window.location.reload();
    }
  }, [action, data]);
  const isActiveAction = useMemo(() => {
    var _a2;
    return !!((_a2 = event.subscription_benefits) == null ? void 0 : _a2[action]);
  }, [action, event.subscription_benefits]);
  const benefitValue = useMemo(() => {
    var _a2;
    let value;
    if (!isActiveAction) {
      return value;
    }
    const benefitsFromAction = data == null ? void 0 : data[action];
    if (benefitsFromAction) {
      value = benefitsFromAction.value;
    } else {
      const possibleBenefits = (_a2 = event.subscription_benefits) == null ? void 0 : _a2[action];
      if (possibleBenefits) {
        let max;
        const benefits = Object.values(possibleBenefits) || [];
        for (const sub of subscriptions) {
          const benefit = benefits.find((ben) => sub.plan._id === ben.subscription_plan_id);
          const value2 = (benefit == null ? void 0 : benefit.value) || 0;
          const validMax = max || 0;
          const condition = valueType === "min" ? value2 < validMax : value2 > validMax;
          if (benefit && condition) {
            max = value2;
          }
        }
        value = max;
      }
    }
    return value;
  }, [isActiveAction, data, action, event.subscription_benefits, subscriptions, valueType]);
  const upgradablePlans = useMemo(() => {
    var _a2, _b;
    let plans = [];
    if (!isActiveAction) {
      return plans;
    }
    const hasAction = data == null ? void 0 : data[action];
    if (hasAction) {
      plans = Object.values(((_a2 = data == null ? void 0 : data[action]) == null ? void 0 : _a2.upgradable_plans) || {});
    } else {
      const possibleBenefits = (_b = event.subscription_benefits) == null ? void 0 : _b[action];
      const possiblePlans = Object.values(possibleBenefits || {});
      const upgradablePlans2 = possiblePlans.filter(
        (plan) => !subscriptions.some((sub) => sub.plan.plan_group._id === plan.subscription_plan_group_id)
      );
      plans = upgradablePlans2;
    }
    return plans;
  }, [action, data, event.subscription_benefits, isActiveAction, subscriptions]);
  const userCurrentBenefits = useMemo(() => {
    var _a2;
    const benefits = [];
    if (!isActiveAction) {
      return benefits;
    }
    const possibleBenefits = (_a2 = event.subscription_benefits) == null ? void 0 : _a2[action];
    if (possibleBenefits) {
      const bens = Object.values(possibleBenefits) || [];
      const actionIds = bens.map((ben) => ben.benefit_action_id);
      for (const sub of subscriptions) {
        const userBenefits = sub.plan.benefits.filter(
          (ben) => actionIds.includes(ben.benefit_action_id || "")
        );
        for (const benefit of userBenefits) {
          const name = `${benefit.benefit_action_title} ${benefit.name}`;
          if (!(benefits == null ? void 0 : benefits.includes(name))) {
            benefits.push(name);
          }
        }
      }
    }
    return benefits;
  }, [isActiveAction, event.subscription_benefits, action, subscriptions]);
  return {
    isActive: active,
    isLoading,
    subscriptions,
    benefitValue,
    upgradablePlans,
    userCurrentBenefits,
    action: data == null ? void 0 : data[action],
    error,
    refetch
  };
};

export {
  useSubscriptionBenefits
};
//# sourceMappingURL=chunk-2NOUJXRY.mjs.map